import { render, staticRenderFns } from "./ChannelCard.vue?vue&type=template&id=2887432c&scoped=true&"
import script from "./ChannelCard.vue?vue&type=script&lang=ts&"
export * from "./ChannelCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2887432c",
  null
  
)

export default component.exports